import { combineReducers } from 'redux'
import { conversations, messages } from './conversations-messages'
import current from './current'
import account from './account'
import appointmentTypes from './appointment-types'
import messageSettings from './message-settings'
import patientGroups from './patient-groups'
import selectedPatient from './selected-patient'
import blastMessages from './blast-messages'
import callLog from './call-log'

export default combineReducers({
  account,
  appointmentTypes,
  blastMessages,
  callLog,
  conversations,
  current,
  messages,
  messageSettings,
  patientGroups,
  selectedPatient,
})



// WEBPACK FOOTER //
// ./src/state/reducers/index.tops.js